import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './footer.scss';

import { Text, FooterLink } from '@ui-kit';
import { 
  KEYMAKER_URL,
  GET_PLUGIN_URL,
  PRICE_URL,
  REFERRAL_URL,
  FAQ_INSTALL_URL,
  PRIVACY_POLICY_URL,
  COOKIE_POLICY_URL,
  TERMS_CONDITIONS_URL
} from "@app/routes";
import { Copyright } from '@widgets';

const FOOTER_MENU = [
  {
    title: 'Product',
    links: [
      { title: 'KeyMaker', path: KEYMAKER_URL },
      { title: 'Get plugin', path: GET_PLUGIN_URL },
      { title: 'Price', path: PRICE_URL },
      { title: 'FAQ', path: FAQ_INSTALL_URL },
      { title: 'Free month', path: REFERRAL_URL },
    ],
  },
  /*{
    title: 'Company',
    links: [
      //{ title: 'About Us', path: ABOUT_US_URL },
      //{ title: 'Career', path: CAREER_URL },
      //{ title: 'Contact', path: CONTACTS_URL },
    ],
  },*/
  {
    title: 'Legal',
    links: [
      { title: 'Privacy Policy', path: PRIVACY_POLICY_URL },
      { title: 'Cookie Policy', path: COOKIE_POLICY_URL },
      //{ title: 'Return Policy', path: RETURN_POLICY_URL },
      { title: 'Terms & Conditions', path: TERMS_CONDITIONS_URL },
      //{ title: 'License Information', path: LICENSES_URL },
    ],
  },
];

const Footer = () => {
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash;

    if (hash && hash === '#main-content') {
      const id = hash.substring(1);
      const domNode = document.getElementById(id);
      domNode.scrollIntoView({ behavior: 'smooth' });
    }
    // eslint-disable-next-line
  }, [location.pathname]);

  const renderMenuList = (menuItem) => {
    if (menuItem.links.length) {
      return menuItem.links.map((link, index) => (
        <li key={`footer__link-${index}`}>
          <FooterLink to={link.path} theme="dark-gray" title={link.title} isBadge={link?.badge}/>
        </li>
      ));
    }
  };
  
  return (
    <footer className="footer">
      <div className="main__container">
        <div className="footer__container d-flex">
          <div className="footer__main d-flex">
          </div>
          <div className="footer__menu d-flex">
            {FOOTER_MENU.map((item, index) => (
              <div key={`footer-${index}`} className="footer__menu-item">
                <Text as="span">{item.title}</Text>
                {renderMenuList(item)}
              </div>
            ))}
          </div>
        </div>
        <Copyright/>
      </div>
    </footer>
  );
};

export default Footer;
